import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { AboutCard } from '../ProductDetail/AboutCard';
import { LocationForm } from './LocationForm';
import { ACTIVE_LOCATIONS, ActiveCountriesEnum } from '../Location/config';
import { locationSlice } from '../../redux/slices/location/slice';
import { useTypedDispatch } from '../../redux/hooks';
import { AnalyticEventsEnum, trackEvent } from '../../Analytics';
import { getLocationFromActivePlace } from '../Location/helpers';

export const Options = ({
  country,
  submitModal,
}: {
  country: ActiveCountriesEnum;
  submitModal: () => void;
}) => {
  const dispatch = useTypedDispatch();
  const { places, flagEmoji } = ACTIVE_LOCATIONS[country];

  return (
    <>
      <Stack padding="10px">
        <p
          style={{
            fontSize: '26px',
            fontFamily: 'Montserrat',
            textAlign: 'center',
            marginBottom: '20px',
          }}
        >
          Select area
        </p>

        <Grid container spacing={1} alignItems="stretch">
          {places
            .filter(p => p.isPopularOutside || p.isPopularInside)
            .map(place => (
              <Grid key={place.placeId} size={6}>
                <AboutCard
                  onClick={async () => {
                    const location = getLocationFromActivePlace(place);

                    trackEvent(AnalyticEventsEnum.LOCATION__SELECTED, {
                      location,
                    });

                    dispatch(
                      locationSlice.actions.setSelectedLocation(location)
                    );

                    submitModal();
                  }}
                  icon={<p style={{ fontSize: '22px' }}>{flagEmoji}</p>}
                  title={place.data.city || place.data.state}
                />
              </Grid>
            ))}
        </Grid>

        <LocationForm submitModal={submitModal} placement="options" />
      </Stack>
    </>
  );
};
